import { apiService } from "@/core/api";
import { API_ENDPOINTS } from "@/core/constants/endpoints";

interface FileUploadResponse {
  fid: Array<{ value: number }>;
  uuid: Array<{ value: string }>;
  uri: Array<{ value: string; url: string }>;
  filename: Array<{ value: string }>;
  filemime?: Array<{ value: string }>;
  filesize?: Array<{ value: number }>;
  status?: Array<{ value: boolean }>;
  created?: Array<{ value: string; format?: string }>;
  changed?: Array<{ value: string; format?: string }>;
}

export class LogoUploadService {
  async uploadFile(file: File): Promise<FileUploadResponse> {
    const entityTypeId = "node";
    const bundle = "partner";
    const fieldName = "field_logo";

    const url = `${API_ENDPOINTS.FILES.UPLOAD}/${entityTypeId}/${bundle}/${fieldName}?_format=json`;

    // Read file as ArrayBuffer for binary upload
    const fileBuffer = await file.arrayBuffer();

    // console.log("Uploading logo file:", {
      // name: file.name,
      // size: file.size,
      // type: file.type,
      // url: url,
    // });

    // Use apiService with binary data and required headers
    const response = await apiService.post<FileUploadResponse>(
      url,
      fileBuffer,
      {
        headers: {
          "Content-Type": "application/octet-stream",
          "Content-Disposition": `file; filename="${file.name}"`,
          Accept: "application/json",
        },
      }
    );

    // console.log("Logo upload response:", response);

    if (!response || !response.uri) {
      throw new Error("Invalid response from server - missing URI");
    }

    return response;
  }
}

export const logoUploadService = new LogoUploadService();
